import Vue from 'vue'
import qs from 'qs'

export default {
  get (locationIds, year, month) {
    const params = {
      location_ids: locationIds,
      year,
      month
    }

    return Vue.http.get(`/reports/transactions`, {
      params,
      paramsSerializer: qs.stringify,
      responseType: 'blob'
    })
  }
}
